import {getAPIbaseURL} from "@/api/config/init";

const prex = `${getAPIbaseURL()}/relatorio/nota_fiscal/`;

export function setRelNotaFiscal(not_hash) {
    return `${prex}${not_hash}`;
}
